import React, {useState} from 'react'
import { apiFetch } from './api'
import { useNavigate } from 'react-router-dom'

export default function Login(){
  const [username,setUsername]=useState('')
  const [password,setPassword]=useState('')
  const [err,setErr]=useState(null)
  const [loading,setLoading]=useState(false)
  const nav = useNavigate()

  const submit = async e =>{
    e.preventDefault()
    setErr(null)
    setLoading(true)
    const form = new URLSearchParams()
    form.append('username', username.trim())
    form.append('password', password.trim())

    try {
      const res = await apiFetch('/api/login', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json'
        },
        credentials: 'include',
        body: JSON.stringify({username: username.trim(), password: password.trim()})
      })

      if (res.ok) {
        const payload = await res.json().catch(()=>null)
        console.debug('Login succeeded', payload)
        nav('/dashboard')
      } else {
        const text = await res.text().catch(()=>null)
        console.warn('Login failed', res.status, text)
        if (res.status === 401) setErr('Login failed — check credentials')
        else setErr('Login failed — server error: ' + (text || res.status))
      }
    } catch (e) {
      console.error('Login fetch error', e)
      setErr('Network error: ' + (e && e.message ? e.message : String(e)) + '. Check backend is running, and CORS/proxy settings (see console).')
    } finally {
      setLoading(false)
    }
  }

  return (
    <div className="login-shell single">
      <div className={`auth-card hero-card ${err ? 'has-error' : ''}`} role="region" aria-labelledby="login-heading">
        <div className="auth-hero compact">
          <div className="hero-left">
            {/* Removed hero badge and logo image for cleaner login page */}
            <h1 className="hero-title brand">Kanika Group of Companies</h1>
            <h2 className="hero-subtitle">Can Monitoring Application</h2>
            <p className="hero-lead">Track opening and closing stock for every supervisor in real time. Bring clarity to routes, returns, and allocations.</p>
            <div className="hero-pills">
              <span className="pill">Live stock pulse</span>
              <span className="pill">Supervisor wise insights</span>
              <span className="pill">Audit ready</span>
            </div>

            <div className="can-stack">
              <div className="can-row">
                <div className="can-anim alt">
                  <div className="can-lid"></div>
                  <div className="can-body alt-body">
                    <div className="can-liquid alt-liquid"></div>
                    <div className="can-liquid alt-liquid delayed"></div>
                    <div className="can-bubble alt-bubble"></div>
                    <div className="can-bubble alt-bubble small"></div>
                    <div className="milk-pour alt-pour"></div>
                  </div>
                  <div className="can-shadow"></div>
                </div>

                <div className="lorry">
                  <div className="lorry-tank">
                    <div className="lorry-tank-band"></div>
                    <div className="lorry-tank-cap"></div>
                  </div>
                  <div className="lorry-bed"></div>
                  <div className="lorry-cabin">
                    <div className="lorry-window"></div>
                  </div>
                  <div className="lorry-wheel wheel-front"></div>
                  <div className="lorry-wheel wheel-left"></div>
                  <div className="lorry-shadow"></div>
                </div>
              </div>
            </div>
          </div>

          <div className="hero-right">
            <div className="form-shell">
              <div className="auth-brand">Sign in</div>
              <h2 id="login-heading" className="auth-title">Welcome back</h2>
              <p className="auth-sub">Secure access to your can monitoring control room.</p>
              {err && <div className="auth-msg error" role="alert" aria-live="assertive">{err}</div>}

              <form onSubmit={submit} className="auth-form" noValidate>
                <div className="form-row">
                  <label htmlFor="username">Username</label>
                  <input id="username" name="username" value={username} onChange={e=>setUsername(e.target.value)} required autoComplete="username" />
                </div>

                <div className="form-row">
                  <label htmlFor="password">Password</label>
                  <input id="password" name="password" type="password" value={password} onChange={e=>setPassword(e.target.value)} required autoComplete="current-password" />
                </div>

                <div className="form-actions">
                  <button className="btn primary" type="submit" disabled={!username || !password || loading} aria-busy={loading}>{loading ? 'Signing in…' : 'Login'}</button>
                </div>
              </form>

              <div className="auth-foot">Don’t have an account? Ask your administrator to create one for you.</div>
            </div>
          </div>
        </div>
      </div>
    </div>
  )
}
